import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@cmde/shadcn";
import { Building2Icon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function EmptyOrganizationsList() {
  const { t } = useTranslation();

  return (
    <Empty className="border border-solid bg-white/30">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Building2Icon />
        </EmptyMedia>
        <EmptyTitle>{t("organizations.list.general.no_organizations_found")}</EmptyTitle>
        <EmptyDescription>
          {t("organizations.list.general.please_contact_support_for_assistance")}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent />
    </Empty>
  );
}
